import styles from './header-styles.module.css';
import { Link, NavLink } from 'react-router-dom';
import { useState, useEffect, useContext } from 'react';

import { useLocation } from 'react-router-dom';
import { UserContext } from '../../../context';
import { useMenuStore } from '../../../store/useMenuStore';
import Aside from '../Aside/Aside';

const Header = () => {
    const [setIsOpen] = useMenuStore((state) => [state.setIsOpen]);

    let location = useLocation();

    const { user } = useContext(UserContext);

    const [isOptimisation, setIsOptimisation] = useState(false);

    useEffect(() => {
        // setIsOpen(false);
        setIsOptimisation(location.search.indexOf('optimisation=true') > -1);
    }, [location, setIsOpen]);

    return (
        <>
            <header className={styles.header} id={'header'}>
                <div className={styles.wrapper}>
                    {/*{!!user && <Aside />}*/}
                    <Aside />
                    <div className={styles.titleWrapper}>
                        <div className={styles.title}>
                            {!user ? (
                                <a href={`${process.env.REACT_APP_LANDING_URL}`}>
                                    <img src={'/logo.svg'} alt="White Thesis" />
                                </a>
                            ) : (
                                <Link to={user ? '/' : '/login'}>
                                    {user ? (
                                        <img src={'/logo.svg'} alt="White Thesis" />
                                    ) : (
                                        <img src={'/logo-full.svg'} alt="White Thesis" />
                                    )}
                                </Link>
                            )}
                        </div>
                    </div>
                    <div className={styles.nav}>
                        {!!user ? (
                            <>
                                <NavLink
                                    className={({ isActive }) =>
                                        (isActive ? styles.active : '') +
                                        ` ${styles.navItem} ${!user ? styles.inactive : ''}  ${
                                            location.pathname === '/legal-structures/expanded' ? styles.activeOpt : ''
                                        }`
                                    }
                                    to={'/legal-structures'}
                                >
                                    Legal structures
                                </NavLink>
                                <NavLink
                                    className={({ isActive }) =>
                                        (!isOptimisation && isActive ? styles.active : '') +
                                        ` ${styles.navItem} ${!user ? styles.inactive : ''}
                                }`
                                    }
                                    to={'/deal-taxes'}
                                >
                                    Deal taxes
                                </NavLink>
                                <NavLink
                                    className={({ isActive }) =>
                                        (isOptimisation || isActive ? styles.active : '') +
                                        ` ${styles.navItem} ${!user ? styles.inactive : ''}`
                                    }
                                    to={'/tax-optimisation'}
                                >
                                    Tax optimisation
                                </NavLink>

                                <NavLink
                                    className={({ isActive }) =>
                                        (isActive ? styles.active : '') +
                                        ` ${styles.navItem} ${!user ? styles.inactive : ''}`
                                    }
                                    to={'/storage'}
                                    onClick={() => {
                                        setIsOpen(false);
                                    }}
                                >
                                    Storage
                                </NavLink>
                            </>
                        ) : (
                            <NavLink
                                className={({ isActive }) =>
                                    (!isOptimisation && isActive ? styles.active : '') +
                                    ` ${styles.navItem} ${!user ? styles.inactive : ''}
                                }`
                                }
                                to={'/'}
                            >
                                Platform
                            </NavLink>
                        )}

                        <NavLink
                            className={({ isActive }) =>
                                (isActive ? styles.active : '') + ` ${styles.navItem} ${!user ? styles.inactive : ''}`
                            }
                            to={'/workflows'}
                            onClick={() => {
                                setIsOpen(false);
                            }}
                        >
                            Workflows
                        </NavLink>

                        {!user && (
                            <NavLink
                                className={({ isActive }) =>
                                    (isActive ? styles.active : '') +
                                    ` ${styles.navItem}
                                }`
                                }
                                to={'/contact'}
                            >
                                Contact us
                            </NavLink>
                        )}
                    </div>
                    <div className={styles.login}>
                        <Link to={user ? '/dashboard' : '/login'}>
                            {user && <span>Hello, {user.username.split(' ')[0]}</span>}

                            <span className={styles.icon}>
                                <img src="/icons/user.svg" alt="" />
                                <img src="/icons/user-active.svg" alt="" className={styles.iconActive} />
                            </span>
                        </Link>
                    </div>
                </div>
            </header>
        </>
    );
};

export default Header;
